export default class CutsceneModel {
  constructor(data) {
    this.data = data;
  }

  getScene(id) {
    return this.data.cutscenes.find((e) => e.id === id);
  }

  getCaptions(sceneId) {
    return this.getScene(sceneId).captions;
  }
}
